import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./locales/en/translation.json";
import arTranslation from "./locales/ar/translation.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  ar: {
    translation: arTranslation,
  },
};

// Function to get stored language preference
const getStoredLanguage = () => {
  if (typeof window !== "undefined") {
    const storedLanguage = localStorage.getItem("apcg2026-preferred-language");
    const hasSelectedLanguage = localStorage.getItem(
      "apcg2026-language-selected"
    );

    // Only use stored language if user has explicitly selected it before
    if (hasSelectedLanguage && storedLanguage) {
      return storedLanguage;
    }
  }
  return "en"; // Default to English
};

i18n
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    lng: getStoredLanguage(), // Use stored language preference
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

// Set initial document direction based on language
if (typeof window !== "undefined") {
  const currentLanguage = i18n.language;
  document.documentElement.dir = currentLanguage === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = currentLanguage;
}

export default i18n;
